import { datadogRum } from '@datadog/browser-rum';
import { environment } from '~environments/environment';
import packageInfo from './package.json';

const env = process.env.NODE_ENV === 'production' ? 'production' : 'staging';
const orgUrl = `${environment.applications.activities.url}/organizations/`;

const setupDatadog = (consent: boolean) => {
  datadogRum.setTrackingConsent(consent ? 'granted' : 'not-granted');

  if (consent) {
    datadogRum.init({
      applicationId: environment.applications.datadog.applicationId,
      clientToken: environment.applications.datadog.clientToken,
      // `site` refers to the Datadog site parameter of your organization
      // see https://docs.datadoghq.com/getting_started/site/
      site: 'datadoghq.eu',
      service: 'activities-front',
      env: env,
      version: packageInfo.version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 10,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      allowedTracingUrls: [
        (url) => url.startsWith(environment.applications.activities.url),
      ],
      beforeSend: (event) => {
        if (
          event.type === 'resource' &&
          event.resource.url.startsWith(orgUrl)
        ) {
          const organizationId = event.resource.url
            .substring(orgUrl.length)
            .split('/')[0];

          datadogRum.setGlobalContextProperty('organization_id', organizationId);
        }
        return true;
      },
    });

    datadogRum.setGlobalContextProperty('business_unit', 'bcp');
    datadogRum.setGlobalContextProperty('invoiced_team', 'ce-api-activities');
  }
};

export default setupDatadog;
